import React, { useCallback, useEffect, useState } from "react"

import Table from "../shared/table"
import UserEventApi from "../services/api/UserEvent.api"
import { IUser } from "../interfaces/user"

const UsersPresent = () => {
  const [users, setUsers] = useState<IUser[]>([])

  const fetchUsers = useCallback(async () => {
    setUsers(
      await new UserEventApi().getAll(null, {
        filters: {
          userEventDay: [
            {
              property: "present",
              value: "1"
            }
          ]
        },
        limit: 1000
      })
    )
  }, [])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <div>
      <Table
        columns={[
          {
            header: "Nom - Prénom - Société",
            accessor: ({ firstName, lastName, UserEvent }: IUser) => (
              <div>
                <strong>
                  {lastName} {firstName}
                </strong>
                &nbsp;-&nbsp;
                {UserEvent?.Employee
                  ? UserEvent?.Employee.Company.name
                  : "Pas de société"}
              </div>
            )
          }
        ]}
        data={users}
      />
    </div>
  )
}

export default UsersPresent
